import FormPage from '@/components/FormPage'
import { createGetParams, createPostParams } from '@/rest'
import {
  formatPhoneNumber,
} from '@/utils'
import security from '@/security'

const formTitle = 'Appoint D288 Full Dealer'

export default {
  extends: FormPage,
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Dealer Kits', disabled: false, to: '/dealer_kits',
        },
        {
          text: 'Dealership', disabled: false, to: '/dealership_kits',
        },
        {
          text: formTitle, disabled: true,
        },
      ],
      title: formTitle,
      // Form steps
      appointmentDetails: {
        fields: {
          msisdn: {
            component: () => import(/* webpackChunkName: "msisdnField" */ '@/components/MsisdnField'),
            name: 'Mobile number',
            props: {
              existing: true,
              noDealer: true,
              hint: 'Subscriber mobile number',
              label: 'Enter mobile number',
              presistentHint: true,
              required: true,
              rules: [val => !!val || 'Mobile number required!'],
            },
          },
          email: {
            component: () => import(/* webpackChunkName: "unrestrictedEmailField" */ '@/components/UnrestrictedEmailField'),
            name: 'Email',
            props: {
              clearable: true,
              hint: 'Email address of the new dealer',
              label: 'Enter email address',
              persistentHint: true,
              required: true,
              rules: [
                val => !!val || 'Email is required!',
                val => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(val) || 'Invalid email!',
              ],
            },
          },

          recipientName: {
            component: () => import(/* webpackChunkName: "textField" */ '@/components/TextField'),
            name: 'Recipient Name',
            props: {
              hint: 'Name of the person receiving the delivery',
              label: 'Enter recipient name',
              required: true,
              rules: [
                val => !!val || 'Recipient name is required!',
              ],
            },
          },

          recipientMobile: {
            component: () => import(/* webpackChunkName: "phoneField" */ '@/components/PhoneField'),
            name: 'Recipient Mobile Number',
            props: {
              hint: 'Contactable mobile number for delivery',
              label: 'Enter recipient mobile number',
              noIcon: true,
              required: true,
              rules: [
                val => !!val || 'Recipient mobile number is required!',
              ],
            },
          },

          deliveryAddress: {
            component: () => import('@/components/TextArea'),
            name: 'Delivery Address',
            props: {
              label: 'Enter delivery address',
              required: true,
              rules: [
                val => !!val || 'Delivery address is required!',
              ],
            },
          },

          deliveryCity: {
            component: () => import('@/components/TextField'),
            name: 'Delivery City',
            props: {
              label: 'Enter city',
              required: true,
              rules: [
                val => !!val || 'City is required!',
              ],
            },
          },

          deliveryPostcode: {
            component: () => import('@/components/TextField'),
            name: 'Delivery Postcode',
            props: {
              label: 'Enter postcode',
              required: true,
              rules: [
                val => !!val || 'Postcode is required!',
              ],
            },
          },

          deliveryState: {
            component: () => import('@/components/StateProvinceField'),
            name: 'Delivery State',
            props: {
              label: 'Select state',
              required: true,
              rules: [
                val => !!val || 'State is required!',
              ],
            },
          },
        },
        title: 'Appointment details',
      },
      submission: {
        fields: {
          notice: {
            component: () => import(/* webpackChunkName: "noticeDifferentUplineDealer" */ '@/components/NoticeDifferentUplineDealer'),
            name: 'Notice',
          },
          msisdn: {
            name: 'Mobile number',
          },
          upline: {
            name: 'Upline Dealer',
          },
          name: {
            name: 'Name',
          },
          email: {
            name: 'Email',
          },
          recipientName: {
            name: 'Recipient Name',
          },
          recipientMobile: {
            name: 'Recipient Mobile Number',
          },
          deliveryAddress: {
            name: 'Delivery Address',
          },

          deliveryCity: {
            name: 'Delivery City',
          },

          deliveryPostcode: {
            name: 'Delivery Postcode',
          },

          deliveryState: {
            name: 'Delivery State',
          },
        },
        submit: false,
        errorMessage: null,
        status: null,
        subTitle: 'Check before submit',
        title: 'Submit',
      },
    }
  },
  computed: {
    formSteps: function () {
      return {
        appointmentDetails: this.appointmentDetails,
        submission: this.submission,
      }
    },
  },
  watch: {
    'appointmentDetails.fields.msisdn.value': function (val) {
      this.submission.fields.msisdn.value = formatPhoneNumber(val)
      if (!val) return

      if ((val.length === 11 && val.startsWith('011')) || (val.length === 10 && !val.startsWith('011'))) {
        const params = createGetParams({
          target: this.appointmentDetails.fields.msisdn.value,
        })
        this.$rest.get('getProfile.php', params)
          .then(response => {
            this.submission.fields.upline.value = response.data.introducer
            this.submission.fields.name.value = response.data.name
            this.plan = response.data.black ? response.data.black : null
            this.submission.fields.notice = security.me.dealerId() === response.data.introducer ? {} : {
              component: () => import(/* webpackChunkName: "noticeDifferentUplineDealer" */ '@/components/NoticeDifferentUplineDealer'),
              name: 'Notice',
            }
          }).catch(() => {
            // ignore
          })
      }
    },

    'appointmentDetails.fields.email.value': function (val) {
      this.submission.fields.email.value = val
    },

    'appointmentDetails.fields.recipientName.value': function (val) {
      this.submission.fields.recipientName.value = val
    },

    'appointmentDetails.fields.recipientMobile.value': function (val) {
      this.submission.fields.recipientMobile.value = val
    },

    'appointmentDetails.fields.deliveryAddress.value': function (val) {
      this.submission.fields.deliveryAddress.value = val
    },

    'appointmentDetails.fields.deliveryCity.value': function (val) {
      this.submission.fields.deliveryCity.value = val
    },

    'appointmentDetails.fields.deliveryPostcode.value': function (val) {
      this.submission.fields.deliveryPostcode.value = val
    },

    'appointmentDetails.fields.deliveryState.value': function (val) {
      this.submission.fields.deliveryState.value = val
    },
  },
  methods: {
    // Override
    async submit () {
      this.submission.submit = true

      const params = createPostParams({
        action: 'createD288Order',
        payload: {
          target: this.appointmentDetails.fields.msisdn.value,
          packageCode: 'D288',
          plan: this.plan,
          email: this.appointmentDetails.fields.email.value,
          recipientName: this.appointmentDetails.fields.recipientName.value,
          recipientMobile: this.appointmentDetails.fields.recipientMobile.value,
          deliveryAddress: this.appointmentDetails.fields.deliveryAddress.value,
          deliveryCity: this.appointmentDetails.fields.deliveryCity.value,
          deliveryPostcode: this.appointmentDetails.fields.deliveryPostcode.value,
          deliveryState: this.appointmentDetails.fields.deliveryState.value,
        },
      })

      try {
        const response = await this.$rest.post('postAction.php', params)
        window.location.href = response.data.paymentUrl
      } catch (e) {
        this.$nextTick(() => {
          this.status = this.submission.status = 'error'
          this.submission.errorMessage = e.message + ': ' + e.response.data
          this.submission.submit = false
        })
      }
    },
  },
}
